import PropTypes from 'prop-types';
import clsx from 'clsx';
import { movementSense } from '../../../utils/simulationEngine';
import { inputCls } from './EditorFields';

/**
 * What one card does to each metric. Positive means MORE of the thing named, not
 * "better" — the colour says which way is good for that metric, so a trainer typing
 * +10 into Downtime sees it turn red.
 */
const MetricDeltas = ({ kpis, value, onChange }) => (
  <div className="grid grid-cols-2 gap-2 sm:grid-cols-3 2xl:grid-cols-5">
    {kpis.map((k) => {
      const v = value?.[k.key];
      const sense = movementSense(k, Number(v) || 0);
      return (
        <label key={k.key} className="block">
          <span className="block truncate text-[10px] font-semibold uppercase tracking-wide text-neutral-500 dark:text-neutral-400">
            {k.label}
          </span>
          <input
            type="number"
            value={v ?? ''}
            onChange={(e) => onChange({ ...value, [k.key]: e.target.value === '' ? '' : Number(e.target.value) })}
            placeholder="0"
            className={clsx(
              inputCls,
              'mt-1 tabular-nums',
              sense === 'good' && 'text-emerald-700 dark:text-emerald-400',
              sense === 'bad' && 'text-red-700 dark:text-red-400'
            )}
          />
        </label>
      );
    })}
  </div>
);

MetricDeltas.propTypes = {
  kpis: PropTypes.arrayOf(PropTypes.object).isRequired,
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired,
};

export default MetricDeltas;
